// extracted by mini-css-extract-plugin
export default {"wrapper":"ElectricityBillChargeSchedule_wrapper__RZfxO","col":"ElectricityBillChargeSchedule_col__udW1I"};